<template>
  <div class="views-selector-v4">
    <div class="views-selector-v4__buttons">
      <CoreButton
        v-for="viewItem in views"
        :key="viewItem.code"
        class="views-selector-v4__btn"
        w100
        :type="getButtonType(viewItem.code)"
        @click="clickView(viewItem)"
      >
        {{ viewItem?.title }}
      </CoreButton>
    </div>
  </div>
</template>

<script>
import CoreButton from '@/components/core/ui/CoreButton'

export default {
  name: 'ViewsSelector',

  components: {
    CoreButton,
  },

  props: {
    selectedView: {
      type: Object,
      default () {
        return null
      },
    },
    views: {
      type: Array,
      default () {
        return []
      },
    },
  },

  emits: ['update:view'],

  data () {
    return {
      selectedViewCode: null,
    }
  },

  created () {
    this.selectedViewCode = this.viewsCodes[0]
  },

  mounted () {
    this.selectViewByRouteParam()
  },

  computed: {
    viewsCodes () {
      return this.views.map(view => view.code)
    },
  },

  methods: {
    getButtonType (viewCode) {
      if (viewCode === this.selectedView?.code) {
        return 'from-var'
      }
      return 'white-grey'
    },

    selectViewByRouteParam () {
      const routeGoalCode = this.$route.params.goal
      if (this.viewsCodes.includes(routeGoalCode)) {
        this.selectedViewCode = routeGoalCode
      }
      const selectedView = this.views.find(view => view.code === this.selectedViewCode)
      if (selectedView) {
        this.clickView(selectedView)
      }
    },

    async clickView (view) {
      this.sendGTMMarkupEvent({
        block: 'new_order_v4',
        element: 'views',
        action: 'change',
      })
      this.$router.replace({
        ...this.$route,
        params: {
          ...this.$route.params,
          goal: view.code,
        },
      })
      this.$emit('selectView', view)
    },
  },
}
</script>

<style lang="scss">
.views-selector-v4 {
  padding: 32px 0;

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 16px;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
  }

  &__btn {
    min-height: 48px;
    max-height: 48px;
    border-radius: 16px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 0;
    text-transform: none;
  }
}
</style>
